import { Text, VStack } from "@chakra-ui/react";
import type { MFRequestFailure } from "state/members/access_v2/catalogs";

// The handover failure is left out: setting a fallback assignee is the
// admin's to fix, and a member can't act on it.
const FailureReason = ({
  failure,
  fallbackHeadline,
}: {
  failure: MFRequestFailure;
  fallbackHeadline?: string | null;
}) => {
  const headline = failure.message ?? fallbackHeadline;
  if (!headline && !failure.hint) return null;

  return (
    <VStack align="flex-start" spacing={0}>
      {headline && (
        <Text variant="lil" fontWeight={600}>
          {headline}
        </Text>
      )}
      {failure.hint && <Text variant="lil">{failure.hint}</Text>}
    </VStack>
  );
};

export default FailureReason;
